<div class="my-5">
  <!-- page-header -->
  <sm-page-header *ngIf="!companyId" [breadcrumb]="breadcrumb" title="settings.address.title"
    description="settings.address.description"> </sm-page-header>

  <!-- content -->

  <div [ngClass]="{ content: !companyId }">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data"
      [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="addressDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="addressDialog"></sm-dialog>
</div>